(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-fixed-message"]) return;
  try {
    
  if (!customElements.get('cb-fixed-message')) {
    customElements.define('cb-fixed-message', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.key = 'cb-message-dismissed:' + this.dataset.messageId;
        this.editor = this.dataset.editor === 'true';
        this.toggle = this.querySelector('.cb-message__toggle');
        this.panel = this.querySelector('.cb-message__panel');
        try { this.dismissed = !this.editor && sessionStorage.getItem(this.key) === '1'; } catch (_) { this.dismissed = false; }
        const show = () => {
          if (!this.dismissed && this.ready && window.scrollY >= Number(this.dataset.scroll)) this.hidden = false;
        };
        this.timer = setTimeout(() => { this.ready = true; show(); }, Number(this.dataset.delay) * 1000);
        window.addEventListener('scroll', show, { ...options, passive: true });
        this.toggle.addEventListener('click', () => {
          if (this.panel.open) return;
          this.scrollOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.panel.showModal();
          this.toggle.setAttribute('aria-expanded', 'true');
        }, options);
        this.querySelector('.cb-message__modal-close').addEventListener('click', () => this.panel.close(), options);
        this.panel.addEventListener('click', (event) => {
          if (event.target !== this.panel) return;
          const rect = this.panel.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.panel.close();
        }, options);
        this.panel.addEventListener('close', () => {
          document.documentElement.style.overflow = this.scrollOverflow;
          this.toggle.setAttribute('aria-expanded', 'false');
          if (this.isConnected && !this.hidden) this.toggle.focus();
        }, options);
        this.querySelector('.cb-message__close').addEventListener('click', () => {
          this.dismissed = true;
          this.hidden = true;
          try { if (!this.editor) sessionStorage.setItem(this.key, '1'); } catch (_) {}
        }, options);
      }
      disconnectedCallback() {
        if (this.panel && this.panel.open) {
          this.panel.close();
          document.documentElement.style.overflow = this.scrollOverflow;
        }
        clearTimeout(this.timer);
        if (this.events) this.events.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-whatsapp-chat"]) return;
  try {
    
  if (!customElements.get('cb-whatsapp-chat')) {
    customElements.define('cb-whatsapp-chat', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const key = 'cb-whatsapp-dismissed-until';
        const editor = this.dataset.editor === 'true';
        const refresh = () => {
          let until = 0;
          try { until = Number(localStorage.getItem(key)) || 0; } catch (_) {}
          this.hidden = !editor && until > Date.now();
        };
        this.querySelector('.cb-whatsapp__close').addEventListener('click', () => {
          this.hidden = true;
          if (!editor) {
            try { localStorage.setItem(key, String(Date.now() + Number(this.dataset.hours) * 3600000)); } catch (_) {}
          }
        }, options);
        window.addEventListener('storage', (event) => { if (event.key === key) refresh(); }, options);
        window.addEventListener('pageshow', refresh, options);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); }, options);
        refresh();
      }
      disconnectedCallback() { if (this.events) this.events.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
  }

  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }

  onEscapePress(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerOverlay = document.querySelector('.header-overlay');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			if (this.headerIsAlwaysSticky) {
				this.header.classList.add('shopify-section-header-sticky');
				this.header.classList.add('always-fixed');
				if (this.headerOverlay) {
					this.headerOverlay.classList.add('color-background-1');
					this.headerOverlay.classList.remove('color-inverse');
				}
			};

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
			}
			} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (document.querySelector(".search-modal.active")) return;
			if (document.querySelector(".burger-drawer.active")) {
				this.header.classList.remove('shopify-section-header-hidden', 'animate');
			};
			if (document.querySelector(".burger-drawer.active")) return;
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
			}
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			if (this.headerOverlay) {
				this.headerOverlay.classList.remove('color-background-1');
				if (!this.classList.contains('mega-menu-open')) {
					this.headerOverlay.classList.add('color-inverse');
				}
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => {
					disclosure.close(); 
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
				if (this.disclosureLists) {
					this.disclosureLists.forEach(disclosureList => {
						disclosureList.setAttribute('hidden', true); 
					});
				}
			this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
			if (this.disclosureButton) {
				this.disclosureButton.forEach(disclosureButton => {
					disclosureButton.setAttribute('aria-expanded', false); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero_special"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(sectionEl){
    if(!sectionEl) return;

    var track  = sectionEl.querySelector('.hero-track');
    var slides = Array.prototype.slice.call(sectionEl.querySelectorAll('.hero-slide'));
    if(!track || slides.length === 0) return;

    var total = slides.length;
    var btnPrev = sectionEl.querySelector('.hero-count--prev');
    var btnNext = sectionEl.querySelector('.hero-count--next');
    var numPrev = sectionEl.querySelector('[data-role="prev"]');
    var numNext = sectionEl.querySelector('[data-role="next"]');

    function pad2(n){ return (n < 10 ? '0' : '') + String(n); }
    function pageWidth(){ return track.clientWidth || 0; }

    function currentIndex(){
      var w = pageWidth() || 1;
      var i = Math.round(track.scrollLeft / w);
      if(i < 0) i = 0;
      if(i > total - 1) i = total - 1;
      return i;
    }

    function goToIndex(i){
      var w = pageWidth() || 0;
      track.scrollTo({ left: i * w, behavior: 'smooth' });
    }

    function updateCounter(){
      var i = currentIndex();
      var prev = (i - 1 + total) % total;
      var next = (i + 1) % total;

      if(numPrev) numPrev.textContent = pad2(prev + 1);
      if(numNext) numNext.textContent = pad2(next + 1);

      if(btnPrev) btnPrev.setAttribute('aria-label', 'Vai alla slide ' + pad2(prev + 1));
      if(btnNext) btnNext.setAttribute('aria-label', 'Vai alla slide ' + pad2(next + 1));
    }

    function onCounterClick(e){
      var i = currentIndex();
      if(e.currentTarget.classList.contains('hero-count--prev')){
        goToIndex((i - 1 + total) % total);
      } else {
        goToIndex((i + 1) % total);
      }
    }

    if(btnPrev) btnPrev.addEventListener('click', onCounterClick);
    if(btnNext) btnNext.addEventListener('click', onCounterClick);

    // Drag / click distinction
    var pointerDown = false;
    var dragging = false;
    var startX = 0;
    var startY = 0;
    var startLeft = 0;
    var dragThreshold = 1;

    function isInteractive(el){
      return el && el.closest('.hero-cta, .hero-count, button, a');
    }

    function onMouseDown(e){
      if(e.button !== 0) return;
      if(isInteractive(e.target)) return;

      pointerDown = true;
      dragging = false;
      startX = e.clientX;
      startY = e.clientY;
      startLeft = track.scrollLeft;
    }

    function onMouseMove(e){
      if(!pointerDown) return;

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if(!dragging && Math.abs(dx) >= dragThreshold && Math.abs(dx) > Math.abs(dy)){
        dragging = true;
        track.classList.add('dragging');
      }

      if(!dragging) return;

      track.scrollLeft = startLeft - dx;
      updateCounter();
      e.preventDefault();
    }

    function onMouseUp(e){
      if(!pointerDown) return;

      var wasDragging = dragging;
      pointerDown = false;
      dragging = false;
      track.classList.remove('dragging');
      updateCounter();

      if(wasDragging) return;

      var slide = e.target.closest('.hero-slide');
      if(!slide) return;
      if(isInteractive(e.target)) return;

      var url = slide.getAttribute('data-slide-url');
      if(url) window.location.href = url;
    }

    function onMouseLeave(){
      if(!pointerDown) return;
      pointerDown = false;
      dragging = false;
      track.classList.remove('dragging');
    }

    track.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    track.addEventListener('mouseleave', onMouseLeave);

    // Keyboard
    track.tabIndex = 0;
    track.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){
        e.preventDefault();
        goToIndex((currentIndex() + 1) % total);
      }
      if(e.key === 'ArrowLeft'){
        e.preventDefault();
        goToIndex((currentIndex() - 1 + total) % total);
      }
    });

    // Snap on resize
    function onResize(){
      var w = pageWidth() || 1;
      var i = currentIndex();

      // Uso 'auto' invece di 'instant' per compatibilità migliore
      track.scrollTo({ left: i * w, behavior: 'auto' });
      updateCounter();
    }
    window.addEventListener('resize', onResize);

    // Animazione: delay sequenziale (main -> extra)
    function applyDelays(slide){
      var items = Array.prototype.slice.call(slide.querySelectorAll('.hero-anim'));
      items.sort(function(a, b){
        var aMain = a.classList.contains('hero-image--main') ? 0 : 1;
        var bMain = b.classList.contains('hero-image--main') ? 0 : 1;
        if(aMain !== bMain) return aMain - bMain;

        var ao = parseInt(a.getAttribute('data-extra-order') || '99', 10);
        var bo = parseInt(b.getAttribute('data-extra-order') || '99', 10);
        return ao - bo;
      });

      var base = 160;
      items.forEach(function(el, idx){
        el.style.animationDelay = (idx * base) + 'ms';
      });
    }

    slides.forEach(applyDelays);

    // Attiva slide in vista
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-active');
        }
        entry.target.querySelectorAll('video').forEach(function(video){
          video.muted = true;
          if(entry.isIntersecting && video.getBoundingClientRect().width > 0){
            var playback = video.play();
            if(playback) playback.catch(function(){});
          } else {
            video.pause();
          }
        });
      });
    }, { root: track, threshold: 0.55 });

    slides.forEach(function(s){
      io.observe(s);
    });

    // Aggiorna counter su scroll
    var raf = null;
    track.addEventListener('scroll', function(){
      if(raf) return;
      raf = requestAnimationFrame(function(){
        raf = null;
        updateCounter();
      });
    }, { passive: true });

    updateCounter();

    function onUnload(){
      window.removeEventListener('resize', onResize);
      if(btnPrev) btnPrev.removeEventListener('click', onCounterClick);
      if(btnNext) btnNext.removeEventListener('click', onCounterClick);
      track.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      track.removeEventListener('mouseleave', onMouseLeave);
      try { io.disconnect(); } catch(e){}
    }

    sectionEl.addEventListener('shopify:section:unload', onUnload);
  }

  function boot(){
    var sectionEl = document.currentScript && document.currentScript.closest('section.hero-special');
    if(!sectionEl) sectionEl = document.querySelector('section.hero-special.hero-special--manual');
    init(sectionEl);
  }

  boot();

  document.addEventListener('shopify:section:load', function(e){
    var sec = e.target.querySelector('section.hero-special.hero-special--manual');
    if(sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	window.addEventListener('DOMContentLoaded', () => {
		class ProductModal extends ModalDialog {
			constructor() {
				super();
			}

			hide() {
				super.hide();
				window.pauseAllMedia();
			}

			show(opener) {
				super.show(opener);
				//this.showActiveMedia();
				this.constProductPageSwiperCall();
			}

			showActiveMedia() {
				this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
						element.classList.remove('active');
					}
				)
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				if (activeMedia) {
					activeMedia.classList.add('active');
					activeMedia.scrollIntoView();
				}
				
				if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
					activeMedia.loadContent();
			}
			constProductPageSwiperCall(showActiveMedia) {
					const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
					let activeMediaIndex = 0
					
					this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
							if(element == activeMedia){
								activeMediaIndex = index
							}
						}
					)
					const prodPageSwiper = new Swiper("#product-page-swiper", {
						zoom: false,
						centeredSlides: false,
						slidesPerView: 1,
						autoheight: true,
						watchSlidesVisibility: false,
						watchSlidesProgress: true,
						observer: true,
						observeParents: true,
						init: false,
						navigation: {
							nextEl: ".swiper-button-next-prod-page",
							prevEl: ".swiper-button-prev-prod-page",
						},
						
						//on: {
						//	click: function (e) {
						//			if (this.zoom.scale === 1) {
						//			this.zoom.in();
						//			} else {
						//				this.zoom.out();
						//			}
						//	 },
						//},
					});
					
						
					prodPageSwiper.on('init', function() {
						prodPageSwiper.slideTo(activeMediaIndex, 0, false);
					});
					prodPageSwiper.init()
					
					document.querySelector('.product-media-modal__toggle').addEventListener("click", function() { 
						if(prodPageSwiper && !prodPageSwiper.destroyed) {
							prodPageSwiper.destroy()
						}
						//prodPageSwiper.destroy() 
					});
					
				}
		}

		class ProductRecommendations extends HTMLElement {
			constructor() {
				super();

				const handleIntersection = (entries, observer) => {
					if (!entries[0].isIntersecting) return;
					observer.unobserve(this);

					fetch(this.dataset.url)
						.then(response => response.text())
						.then(text => {
							const html = document.createElement('div');
							html.innerHTML = text;
							const recommendations = html.querySelector('product-recommendations--single');
							if (recommendations && recommendations.innerHTML.trim().length) {
								this.innerHTML = recommendations.innerHTML;
							}
						})
						.catch(e => {
							console.error(e);
						});
				}

				new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
			}
		}

		customElements.define('product-modal', ProductModal);
		customElements.define('product-recommendations--single', ProductRecommendations);
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {



						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					


						var swiper = new Swiper(".swiper-container", {
							slidesPerView: 1,

								spaceBetween: 1,
								navigation: {
									nextEl: ".product-button-group .swiper-button-next-1",
									prevEl: ".product-button-group .swiper-button-prev-1",
								},
								pagination: {
									el: ".product-card-pagination",
									clickable: true,
								},
						});
						const initAnimated = () => {
							const blocks = document.querySelectorAll(".animated-block:not(.visible)");

							const observer = new IntersectionObserver(
									(entries) => {
											entries.forEach((entry) => {
													if (entry.isIntersecting) {
															const block = entry.target;
															block.classList.add("visible");
															observer.unobserve(block);
													}
											});
									},
									{ threshold: 0.1 } 
							);

							blocks.forEach((block) => {
									observer.observe(block);
							});
						};
						initAnimated();
						const cursorProgress = (productSwiper) => {
							const cursor = productSwiper.querySelector(".product__cursor");
							const cursorIcon = productSwiper.querySelector("#cursor-icon1");
						
							const animateCursor = (e) => {
								const contentRect = productSwiper.getBoundingClientRect();
								const x = e.clientX - contentRect.left - 12;
								const y = e.clientY - contentRect.top - 12;
						
								cursor.animate(
									{ transform: `translate(${x}px, ${y}px)` },
									{ duration: 300, fill: "forwards" }
								);
							};
						
							const getCursorClass = (position, width) => {
								return position < width / 2 ? "prev" : "next";
							};
						
							productSwiper.addEventListener("mousemove", (e) => {
								if (!e.target.closest(".link") &&
				!e.target.closest(".swiper-pagination") ) {
					cursor.classList.add("active");
				} else {
					cursor.classList.remove("active");
				}


								
						
								animateCursor(e);
						
								const position = e.clientX - productSwiper.getBoundingClientRect().left;
								cursor.dataset.type = getCursorClass(position, productSwiper.clientWidth);
						
								cursorIcon.className = cursor.dataset.type; 
						
								
							});
						
							productSwiper.addEventListener("mouseleave", () => {
								cursor.classList.remove("active");
							});
						};
						
		
							const productCards = document.querySelectorAll(".card--product_cursor");
							productCards.forEach((productCard) => cursorProgress(productCard));
							const buttonHoverEffects= () => {
	
	if (window.innerWidth < 1200) return;
	function wrapLetters(element) {
			const text = element.textContent.trim();
			element.innerHTML = '';

			const wrapperSpan = document.createElement('span');
			wrapperSpan.className = 'wrapper';

			Array.from(text).forEach((char, charIndex) => {
					const charSpan = document.createElement('span');
					charSpan.className = 'char';
					charSpan.textContent = char;
					charSpan.style.setProperty('--char-index', charIndex + 1);
					wrapperSpan.appendChild(charSpan);
			});

			element.appendChild(wrapperSpan);
	}

	document.querySelectorAll("[hoverstagger='text']").forEach(wrapLetters);
}

buttonHoverEffects()

					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();
})();
